//  import React, { createContext, useEffect, useState } from "react";

// export const DataContext = createContext();

// export const DataProvider = ({ children }) => {
//   const [data, setData] = useState([]);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await fetch(
//         "https://dpsladwa.com/Dpsschool_Data/get_content.php",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "text/plain",
//           },
//           body: JSON.stringify({
//             origin: "DEL",
//             destination: "BOM",
//             departure_date: "2026-05-20",
//             adults: 1,
//           }),
//         }
//       );

//       const result = await response.json();
//       setData(result.data);
//     } catch (error) {
//       console.log("API ERROR:", error);
//     }
//   };

//   return (
//     <DataContext.Provider value={{ data }}>
//       {children}
//     </DataContext.Provider>
//   );
// };

// import React, { createContext, useEffect, useState } from "react";

// export const DataContext = createContext();

// export const DataProvider = ({ children }) => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     loadData();
//   }, []);

//   const loadData = async () => {
//     try {
//       // 🔥 1. Check localStorage first
//       const cachedData = localStorage.getItem("schoolData");

//       if (cachedData) {
//         console.log("⚡ Loaded from cache");
//         setData(JSON.parse(cachedData));
//         setLoading(false);
//         return; // ❌ API call skip
//       }

//       // 🌐 2. If no cache → fetch API
//       console.log("🌐 Fetching from API...");

//       const response = await fetch(
//         "https://dpsladwa.com/Dpsschool_Data/get_content.php",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "text/plain",
//           },
//           body: JSON.stringify({
//             origin: "DEL",
//             destination: "BOM",
//             departure_date: "2026-05-20",
//             adults: 1,
//           }),
//         }
//       );

//       const result = await response.json();

//       // 🔥 3. Save to state + localStorage
//       setData(result.data);
//       localStorage.setItem("schoolData", JSON.stringify(result.data));

//       setLoading(false);
//     } catch (error) {
//       console.log("API ERROR:", error);
//       setLoading(false);
//     }
//   };

//   return (
//     <DataContext.Provider value={{ data, loading }}>
//       {children}
//     </DataContext.Provider>
//   );
// };

import React, { createContext, useEffect, useState } from "react";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      // ✅ 1. Load from cache first (fast UI)
      const cachedData = localStorage.getItem("schoolData");
console.log('here ismy data', cachedData)
      if (cachedData) {
        console.log("⚡ Loaded from cache");
        setData(JSON.parse(cachedData));
        setLoading(false); // UI immediately show
      }

      // ✅ 2. Always fetch fresh data (IMPORTANT)
      console.log("🌐 Fetching fresh data...");

      const response = await fetch(
        "https://dpsladwa.com/Dpsschool_Data/get_content.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "text/plain",
          },
          body: JSON.stringify({
            origin: "DEL",
            destination: "BOM",
            departure_date: "2026-05-20",
            adults: 1,
          }),
        }
      );

      const result = await response.json();

      // ✅ 3. Update ONLY if data changed (optional but best)
      const newData = JSON.stringify(result.data);
      const oldData = localStorage.getItem("schoolData");

      if (newData !== oldData) {
        console.log("🔄 New data found → updating");
        setData(result.data);
        localStorage.setItem("schoolData", newData);
      } else {
        console.log("✅ Data already up-to-date");
      }

      setLoading(false);
    } catch (error) {
      console.log("API ERROR:", error);
      setLoading(false);
    }
  };

  return (
    <DataContext.Provider value={{ data, loading }}>
      {children}
    </DataContext.Provider>
  );
};